import { MagazineLesson } from '../types/trimestersSettings.types';

const delay = <T,>(data: T, timeout = 250): Promise<T> =>
  new Promise((resolve) => {
    window.setTimeout(() => resolve(data), timeout);
  });

const buildEmptyLessons = (magazineId: string): MagazineLesson[] =>
  Array.from({ length: 13 }, (_, index) => ({
    id: `${magazineId}-${index + 1}`,
    number: index + 1,
    title: '',
    summary: '',
    biblicalReference: '',
  }));

export const lessonsService = {
  buildEmptySet: async (magazineId: string) => delay(buildEmptyLessons(magazineId)),
  updateMany: async (lessons: MagazineLesson[]) => delay(lessons.map((lesson) => ({ ...lesson }))),
};
